(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var sectionId = drawer.getAttribute('data-section-id');
    var pendingLineKey = null;
    var refreshInFlight = null;
    var refreshQueued = false;
    var pendingCartSnapshot = null;
    var changeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!changeUrl.endsWith('/')) changeUrl += '/';
    changeUrl += 'cart/change.js';

    function findLine(lineKey) {
      if (!lineKey) return null;
      var escaped = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(lineKey) : lineKey.replace(/"/g, '\\"');
      return drawer.querySelector('[data-cart-line="' + escaped + '"]');
    }

    function setQtyLoading(lineKey, loading) {
      if (!lineKey) return;
      var line = findLine(lineKey);
      if (!line) return;
      var qty = line.querySelector('[data-cart-qty]');
      var spinner = line.querySelector('[data-cart-qty-spinner]');
      if (!qty) return;
      if (loading) {
        qty.setAttribute('data-loading', 'true');
        qty.setAttribute('aria-busy', 'true');
        if (spinner) spinner.hidden = false;
      } else {
        qty.removeAttribute('data-loading');
        qty.setAttribute('aria-busy', 'false');
        if (spinner) spinner.hidden = true;
      }
    }

    function clearQtyLoading() {
      if (pendingLineKey) setQtyLoading(pendingLineKey, false);
      pendingLineKey = null;
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
        if (count > 0) {
          badge.textContent = String(count);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
      var drawerCount = drawer.querySelector('[data-cart-drawer-count]');
      if (drawerCount) drawerCount.textContent = String(count);
    }

    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    function openDrawer() {
      setOpen(true);
      refreshDrawer();
    }

    function closeDrawer() {
      setOpen(false);
    }

    function bindDrawerEvents() {
      drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });

      drawer.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-line-key');
          var quantity = parseInt(btn.getAttribute('data-quantity'), 10);
          if (!key || isNaN(quantity)) return;
          changeQuantity(key, quantity);
        });
      });

      drawer.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-line-key');
          if (!key) return;
          changeQuantity(key, 0);
        });
      });
    }

    function notifyCartDrawerReady(cart) {
      var detail = cart ? { cart: cart } : {};
      document.dispatchEvent(
        new CustomEvent('tonica-b2b:cart-updated', { bubbles: true, detail: detail })
      );
    }

    function refreshDrawer(lineKey, cart) {
      if (!sectionId) return Promise.resolve();
      if (cart) pendingCartSnapshot = cart;
      if (lineKey) {
        pendingLineKey = lineKey;
        setQtyLoading(lineKey, true);
      }
      if (refreshInFlight) {
        refreshQueued = true;
        return refreshInFlight;
      }

      refreshInFlight = fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-cart-drawer]');
          if (!next) return;
          var wasOpen = drawer.getAttribute('data-open') === 'true';
          var activeLineKey = pendingLineKey;
          drawer.innerHTML = next.innerHTML;
          drawer.setAttribute('data-open', wasOpen ? 'true' : 'false');
          if (activeLineKey) setQtyLoading(activeLineKey, true);
          bindDrawerEvents();
          notifyCartDrawerReady(pendingCartSnapshot);
          pendingCartSnapshot = null;
        })
        .finally(function () {
          clearQtyLoading();
          refreshInFlight = null;
          if (refreshQueued) {
            refreshQueued = false;
            refreshDrawer();
          }
        });

      return refreshInFlight;
    }

    function changeQuantity(lineKey, quantity) {
      pendingLineKey = lineKey;
      setQtyLoading(lineKey, true);
      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity }),
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
          );
          return refreshDrawer(lineKey, cart);
        })
        .catch(function () {
          clearQtyLoading();
        });
    }

    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeDrawer();
    });

    document.addEventListener('cart:open', openDrawer);
    document.addEventListener('cart:refresh', refreshDrawer);

    bindDrawerEvents();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-page]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id');
    var pendingLineKey = null;
    var refreshInFlight = null;
    var refreshQueued = false;
    var pendingCartSnapshot = null;
    var changeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!changeUrl.endsWith('/')) changeUrl += '/';
    changeUrl += 'cart/change.js';

    function findLine(lineKey) {
      if (!lineKey) return null;
      var escaped = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(lineKey) : lineKey.replace(/"/g, '\\"');
      return root.querySelector('[data-cart-line="' + escaped + '"]');
    }

    function setQtyLoading(lineKey, loading) {
      if (!lineKey) return;
      var line = findLine(lineKey);
      if (!line) return;
      var qty = line.querySelector('[data-cart-qty]');
      var spinner = line.querySelector('[data-cart-qty-spinner]');
      if (!qty) return;
      if (loading) {
        qty.setAttribute('data-loading', 'true');
        qty.setAttribute('aria-busy', 'true');
        if (spinner) spinner.hidden = false;
      } else {
        qty.removeAttribute('data-loading');
        qty.setAttribute('aria-busy', 'false');
        if (spinner) spinner.hidden = true;
      }
    }

    function clearQtyLoading() {
      if (pendingLineKey) setQtyLoading(pendingLineKey, false);
      pendingLineKey = null;
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
        if (count > 0) {
          badge.textContent = String(count);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
    }

    function bindEvents() {
      root.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-line-key');
          var quantity = parseInt(btn.getAttribute('data-quantity'), 10);
          if (!key || isNaN(quantity)) return;
          changeQuantity(key, quantity);
        });
      });

      root.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-line-key');
          if (!key) return;
          changeQuantity(key, 0);
        });
      });
    }

    function notifyCartPageReady(cart) {
      var detail = cart ? { cart: cart } : {};
      document.dispatchEvent(
        new CustomEvent('tonica-b2b:cart-updated', { bubbles: true, detail: detail })
      );
    }

    function refreshPage(lineKey, cart) {
      if (!sectionId) return Promise.resolve();
      if (cart) pendingCartSnapshot = cart;
      if (lineKey) {
        pendingLineKey = lineKey;
        setQtyLoading(lineKey, true);
      }
      if (refreshInFlight) {
        refreshQueued = true;
        return refreshInFlight;
      }

      refreshInFlight = fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-cart-page]');
          if (!next) return;
          var activeLineKey = pendingLineKey;
          root.innerHTML = next.innerHTML;
          root.setAttribute('data-section-id', sectionId);
          if (activeLineKey) setQtyLoading(activeLineKey, true);
          bindEvents();
          notifyCartPageReady(pendingCartSnapshot);
          pendingCartSnapshot = null;
        })
        .finally(function () {
          clearQtyLoading();
          refreshInFlight = null;
          if (refreshQueued) {
            refreshQueued = false;
            refreshPage();
          }
        });

      return refreshInFlight;
    }

    function changeQuantity(lineKey, quantity) {
      pendingLineKey = lineKey;
      setQtyLoading(lineKey, true);
      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity }),
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
          );
          return refreshPage(lineKey, cart);
        })
        .catch(function () {
          clearQtyLoading();
        });
    }

    bindEvents();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('[data-lights-toggle]');
    if (!toggle) return;
    var label = toggle.querySelector('[data-lights-label]');
    var onLabel = toggle.getAttribute('data-on-label') || 'On';
    var offLabel = toggle.getAttribute('data-off-label') || 'Off';
    var initialState = toggle.getAttribute('data-lights-initial-state') || 'off';
    var stored = null;
    try { stored = sessionStorage.getItem('carpyen-lights'); } catch (e) {}
    // lampOn === true  => lamp lit (glow image, 'lights-off' class present) => "On" label.
    // The button reflects the current lamp state, not the action.
    var lampOn = stored === 'on' || (stored !== 'off' && initialState === 'on');
    apply(lampOn);
    toggle.addEventListener('click', function () {
      lampOn = !document.documentElement.classList.contains('lights-off');
      apply(lampOn);
      try { sessionStorage.setItem('carpyen-lights', lampOn ? 'on' : 'off'); } catch (e) {}
    });
    function apply(on) {
      document.documentElement.classList.toggle('lights-off', on);
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (label) label.textContent = on ? onLabel : offLabel;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var mobileToggle = header.querySelector('[data-mobile-toggle]');
    var mobileDrawer = header.querySelector('[data-mobile-drawer]');
    var searchToggles = header.querySelectorAll('[data-search-toggle]');
    var searchClose = header.querySelector('[data-search-close]');
    var searchOverlay = header.querySelector('[data-search-overlay]');
    var root = document.documentElement;

    function getVisibleSearchToggle() {
      var toggles = header.querySelectorAll('[data-search-toggle]');
      for (var i = 0; i < toggles.length; i++) {
        var el = toggles[i];
        var rect = el.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) continue;
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') continue;
        return el;
      }
      return null;
    }

    function updateHeaderMetrics() {
      var rect = header.getBoundingClientRect();
      root.style.setProperty('--header-height', rect.height + 'px');
      root.style.setProperty('--header-top', rect.top + 'px');

      var nav = header.querySelector('.site-header__nav');
      if (nav) {
        var navRect = nav.getBoundingClientRect();
        var navStyle = window.getComputedStyle(nav);
        var paddingLeft = parseFloat(navStyle.paddingLeft) || 0;
        var paddingRight = parseFloat(navStyle.paddingRight) || 0;

        root.style.setProperty('--header-container-left', navRect.left + 'px');
        root.style.setProperty('--header-container-width', navRect.width + 'px');
        root.style.setProperty('--header-container-padding-left', navStyle.paddingLeft);
        root.style.setProperty('--header-container-padding-right', navStyle.paddingRight);

        var toggle = getVisibleSearchToggle();
        var isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (isDesktop && toggle) {
          var toggleRect = toggle.getBoundingClientRect();
          root.style.setProperty('--search-toggle-top', toggleRect.top + 'px');
          root.style.setProperty('--search-toggle-left', toggleRect.left + 'px');
          root.style.setProperty('--search-toggle-width', toggleRect.width + 'px');
          root.style.setProperty('--search-toggle-height', toggleRect.height + 'px');

          var barContentWidth = navRect.width - paddingLeft - paddingRight;
          var toggleOffset = toggleRect.left - (navRect.left + paddingLeft);
          var inputPaddingRight = Math.max(0, barContentWidth - toggleOffset);
          root.style.setProperty('--search-input-padding-right', inputPaddingRight + 'px');
        } else {
          root.style.setProperty('--search-input-padding-right', '0px');
        }
      }
    }

    function observeHeaderMetrics() {
      updateHeaderMetrics();

      if (typeof ResizeObserver === 'undefined') {
        window.addEventListener('resize', updateHeaderMetrics);
        return;
      }

      var resizeObserver = new ResizeObserver(function () {
        updateHeaderMetrics();
      });

      resizeObserver.observe(header);

      var headerSection = header.closest('.shopify-section');
      if (headerSection) {
        resizeObserver.observe(headerSection);
        if (headerSection.previousElementSibling) {
          resizeObserver.observe(headerSection.previousElementSibling);
        }
      }

      var headerGroup = header.closest('[id^="shopify-section-group-"]');
      if (headerGroup) {
        resizeObserver.observe(headerGroup);
      }

      window.addEventListener('resize', updateHeaderMetrics);
      window.addEventListener(
        'scroll',
        function () {
          if (searchOverlay && searchOverlay.getAttribute('data-open') === 'true') {
            updateHeaderMetrics();
          }
        },
        { passive: true }
      );
    }

    observeHeaderMetrics();

    function setMobileOpen(open) {
      if (!mobileDrawer) return;
      mobileDrawer.setAttribute('data-open', open ? 'true' : 'false');
      mobileDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      header.setAttribute('data-mobile-open', open ? 'true' : 'false');
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        document.documentElement.style.overflow = 'hidden';
      } else if (!searchOverlay || searchOverlay.getAttribute('data-open') !== 'true') {
        document.documentElement.style.overflow = '';
      }
    }

    function openMobileMenu() {
      closeSearch();
      setMobileOpen(true);
    }

    function closeMobileMenu() {
      setMobileOpen(false);
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        var open = mobileDrawer && mobileDrawer.getAttribute('data-open') === 'true';
        if (open) closeMobileMenu();
        else openMobileMenu();
      });
    }

    if (mobileDrawer) {
      mobileDrawer.querySelectorAll('[data-mobile-close]').forEach(function (el) {
        el.addEventListener('click', closeMobileMenu);
      });
    }

    function openSearch() {
      if (!searchOverlay) return;
      closeMobileMenu();
      updateHeaderMetrics();
      searchOverlay.setAttribute('data-open', 'true');
      searchOverlay.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(updateHeaderMetrics);
      var input = searchOverlay.querySelector('input[type="search"], input[name="q"]');
      if (input)
        setTimeout(function () {
          input.focus();
        }, 50);
      document.documentElement.style.overflow = 'hidden';
    }
    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.setAttribute('data-open', 'false');
      searchOverlay.setAttribute('aria-hidden', 'true');
      if (!mobileDrawer || mobileDrawer.getAttribute('data-open') !== 'true') {
        document.documentElement.style.overflow = '';
      }
    }
    searchToggles.forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeSearch();
        closeMobileMenu();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid-app"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var appRoot = document.querySelector('.image-grid-app__app');
    if (!appRoot) return;

    function getFieldLabel(input) {
      if (!input) return '';
      if (input.placeholder) return input.placeholder.trim();
      if (input.tagName === 'SELECT') {
        var placeholderOption = input.querySelector('option[disabled], option[value=""]');
        if (placeholderOption && placeholderOption.textContent.trim()) {
          return placeholderOption.textContent.trim();
        }
      }
      return '';
    }

    function isFieldVisible(field) {
      if (!field || field.closest('[hidden]') || field.hasAttribute('hidden')) return false;

      var el = field;
      while (el && el !== appRoot) {
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
        el = el.parentElement;
      }

      return true;
    }

    function promoteFieldToLabel(field) {
      if (field.tagName === 'LABEL') return field;
      if (field.tagName !== 'DIV') return field;

      var labelField = document.createElement('label');
      labelField.className = field.className;

      Array.prototype.forEach.call(field.attributes, function (attr) {
        if (attr.name === 'class') return;
        labelField.setAttribute(attr.name, attr.value);
      });

      while (field.firstChild) {
        labelField.appendChild(field.firstChild);
      }

      field.parentNode.replaceChild(labelField, field);
      return labelField;
    }

    function enhanceSelects() {
      var chevronTpl = document.querySelector('.image-grid-app__chevron-template');

      appRoot.querySelectorAll('.tonica-b2b-field select, .image-grid-app__field select').forEach(function (select) {
        if (select.closest('[hidden]') || select.closest('.image-grid-app__select')) return;

        var field = select.closest('.tonica-b2b-field, .image-grid-app__field');
        if (!field || !isFieldVisible(field)) return;

        var wrap = document.createElement('span');
        wrap.className = 'image-grid-app__select';
        select.parentNode.insertBefore(wrap, select);
        wrap.appendChild(select);

        var icon = document.createElement('span');
        icon.className = 'image-grid-app__select-icon';
        icon.setAttribute('aria-hidden', 'true');
        if (chevronTpl && chevronTpl.content.firstElementChild) {
          icon.appendChild(chevronTpl.content.firstElementChild.cloneNode(true));
        }
        wrap.appendChild(icon);

        function syncSelectState() {
          var field = select.closest('.tonica-b2b-field, .image-grid-app__field');
          if (!field) return;
          field.classList.toggle('is-select-empty', !select.value);
        }

        select.addEventListener('change', syncSelectState);
        syncSelectState();
      });
    }

    function enhanceFields() {
      appRoot.querySelectorAll('.tonica-b2b-field').forEach(function (field) {
        if (!isFieldVisible(field)) return;
        if (field.querySelector('.image-grid-app__label')) return;

        var input = field.querySelector('input, select, textarea');
        if (!input) return;

        var labelText = getFieldLabel(input);
        if (!labelText || labelText === '---') return;

        var label = document.createElement('span');
        label.className = 'image-grid-app__label';
        label.textContent = labelText;
        field.insertBefore(label, input);
        field.classList.add('image-grid-app__field');

        if (input.placeholder) input.removeAttribute('placeholder');
        if (input.tagName === 'SELECT') {
          var placeholderOption = input.querySelector('option[disabled], option[value=""]');
          if (placeholderOption && !placeholderOption.value) {
            placeholderOption.textContent = '';
          }
          input.classList.add('image-grid-app__select-input');
        }

        promoteFieldToLabel(field);
      });

      enhanceSelects();
    }

    function runEnhancements() {
      enhanceFields();
      injectStyleOverrides();
    }

    runEnhancements();

    function injectStyleOverrides() {
      if (document.getElementById('image-grid-app-overrides')) return;
      var style = document.createElement('style');
      style.id = 'image-grid-app-overrides';
      style.textContent = [
        '.image-grid-app__app .tonica-b2b-register__input:not(select),',
        '.image-grid-app__app .register-input:not(select) {',
        '  background: transparent !important;',
        '  border: 0 !important;',
        '  box-shadow: none !important;',
        '  font-size: 0.875rem !important;',
        '  line-height: 1.25rem !important;',
        '  font-weight: 400 !important;',
        '  letter-spacing: 0.01em !important;',
        '  color: var(--foreground) !important;',
        '  padding: 0 !important;',
        '  border-radius: 0 !important;',
        '}',
        '.image-grid-app__app select.register-input,',
        '.image-grid-app__app select.register-select,',
        '.image-grid-app__app select.tonica-b2b-register__input {',
        '  background: transparent !important;',
        '  border: 0 !important;',
        '  box-shadow: none !important;',
        '  font-size: 0.875rem !important;',
        '  line-height: 1.25rem !important;',
        '  font-weight: 400 !important;',
        '  letter-spacing: 0.01em !important;',
        '  color: var(--foreground) !important;',
        '  padding: 0 1.5rem 0 0 !important;',
        '  border-radius: 0 !important;',
        '}',
        '.image-grid-app__app .tonica-b2b-field.is-select-empty select,',
        '.image-grid-app__app .image-grid-app__field.is-select-empty select {',
        '  color: color-mix(in srgb, var(--muted-foreground) 50%, transparent) !important;',
        '}',
        '.image-grid-app__app .register-submit-button,',
        '.image-grid-app__app .tonica-b2b-register__submit {',
        '  background-color: var(--foreground) !important;',
        '  color: var(--background) !important;',
        '  border: 0 !important;',
        '  border-radius: 0 !important;',
        '  text-transform: uppercase !important;',
        '  letter-spacing: 0.15em !important;',
        '  height: 3rem !important;',
        '  font-size: 0.75rem !important;',
        '}',
      ].join('\n');
      document.head.appendChild(style);
    }

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        runEnhancements();
      });
      observer.observe(appRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden', 'style', 'class'],
      });
    }

    setTimeout(runEnhancements, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductList(section) {
      if (section.dataset.carousel !== 'true') return;

      var track = section.querySelector('[data-product-list-track]');
      var pages = track ? track.querySelectorAll('.product-list__page') : [];
      if (!track || pages.length < 2) return;

      var prevBtn = section.querySelector('[data-product-list-prev]');
      var nextBtn = section.querySelector('[data-product-list-next]');
      var dotsRoot = section.querySelector('[data-product-list-dots]');
      var current = 0;

      pages.forEach(function (_, index) {
        if (!dotsRoot) return;
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-list__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Page ' + (index + 1));
        dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          goTo(index);
        });
        dotsRoot.appendChild(dot);
      });

      var dots = dotsRoot ? dotsRoot.querySelectorAll('.product-list__dot') : [];

      function goTo(index) {
        current = Math.max(0, Math.min(index, pages.length - 1));
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === pages.length - 1;
        dots.forEach(function (dot, i) {
          var active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
        });
      }

      goTo(0);
    }

    document.querySelectorAll('[data-product-list]').forEach(initProductList);
  })();

  } catch(e) { console.error(e); }
})();
})();
